import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataController, { IDataController } from '@/lib/DataController';
import { DCRecord } from '@/@types/lib/dataController';
import LoaderContext, { LoaderContextType } from '@/context/LoaderContext/LoaderContext';
import DynamicFormsModel from '@/models/dynamic_forms_model';
import ModelTable from '@/ui/Table/ModelTable';
import TableButtonEdit from '@/ui/Table/ActionButtons/TableButtonEdit';
import DynamicFormsDialog from './DynamicFormsDialog';
import DialogContext, { DialogContextType } from '@/context/DialogContext/DialogContext';

const DynamicFormsTable = () => {
  const [records, setRecords] = useState<DCRecord[]>([]);
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { showDialog } = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;

  const dc: IDataController = new DataController(DynamicFormsModel);

  useEffect(() => {
    refreshRecords();
  }, []);

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData()
      .then((resp) => {
        if (resp.success) {
          if (Array.isArray(resp.data)) {
            setRecords(resp.data);
          } else {
            setRecords([]);
          }
        }
      })
      .finally(() => {
        loaderContext.toggleLoading(false);
      });
  };
  
  const handleAdd = () => {
    showDialog(DynamicFormsDialog, {
      dc,
      mode: 'insert',
      form: 'insert',
      onClose: handleDialogClose,
    });
  };

  const handleEdit = (
    evt: React.SyntheticEvent,
    sel: { [key: string]: DCRecord }
  ) => {
    const selId = Object.keys(sel)[0]; 
    navigate(`/admin/dynamic_forms/${  sel[selId].id}`);
  };

  const handleDialogClose = (result: {
    dataChanged: boolean;
    action: string;
    id: number;
  }) => {
    if (result.dataChanged) {
      refreshRecords();
    }
    if (result.action === 'insert') {
      // console.log("result", result)
      navigate(`/admin/dynamic_forms/${result.id}`);
    }
  };


  return (
    <ModelTable
      title={t('admin:titles.dynamic_froms')}
      records={records}
      dc={dc}
      allowSelection="one"
      allowFilter
      allowExport
      allowAdd
      allowColumnPicker
      addLabel={t('buttons.new_m') as string}
      handleAdd={handleAdd}
      onRowAction={() => {}}
      allowRowAction={() => true}
      unselectRow={false}
      onDoubleClick={handleEdit}
    >
      <TableButtonEdit variant="contained" onClick={handleEdit} />
    </ModelTable>
  );
}

export default DynamicFormsTable;